import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AdminService } from '../../services/admin';
import Swal from 'sweetalert2';
import { Popup } from 'ng2-opd-popup';
import { Agent_Mef } from 'model/modal-cms/aget_mef';


declare var mdtoast: any;
var success_message = mdtoast("Statistique de consultation médicale. Chargement de donnée...", { duration: 5000, init: true, type: mdtoast.SUCCESS });
var success_message2 = mdtoast("Statistique de répos médicale. Chargement de donnée...", { duration: 5000, init: true, type: mdtoast.SUCCESS });
var success_message3 = mdtoast("Statistique de remboursement. Chargement de donnée... ", { duration: 5000, init: true, type: mdtoast.SUCCESS });
var success_message4 = mdtoast("Agent inscrit. Chargement de donnée... ", { duration: 5000, init: true, type: mdtoast.SUCCESS });


@Component({
  selector: 'app-consulatation-medicale',
  templateUrl: './consulatation-medicale.component.html',
  styleUrls: ['./consulatation-medicale.component.scss']
})
export class ConsulatationMedicaleComponent implements OnInit {
  mode_dr : any = 11;
  motCle: any ;
  mode_recherche:number=1;
  listeatt_by_dr: any;
  date_clic: Date;
  agent_iscrit:any;
  agent_Mef : Agent_Mef;
  @ViewChild('popupProcedure') popupProcedure: Popup;
  constructor(private router: Router,public adminService: AdminService ) { }

  ngOnInit() {
    this.getListeAttenteParMed();
    this.agent_iscrit = this.adminService.getUserIscrit();    
  }


  recupererInfoAgent


  


  SeeDoctorANS(id:number){   
    this.router.navigate(['cons-procedure/'+id]);
  }
  SeeDoctorTSZ(id:number){
    this.router.navigate(['cons-procedure/'+id]);
  }
  SeeDoctorANT(id:number){
    this.router.navigate(['cons-procedure/'+id]);
  }


  getListeAttenteParMed(){
    this.adminService.getListeAttenteParMed()
    .subscribe(data => {
      this.listeatt_by_dr = data;
      this.date_clic= new Date();
      console.log("this.listeatt_by_dr"+this.listeatt_by_dr)
    }, err => {
      console.log(err);
    })
  }

  getParLieu(){
    this.mode_recherche = 1;
  }

  getParSite(){
    this.mode_recherche = 2;
  }


  RechercheMedParIM(){
  // let a =this.agent_Mef.agent_matricule
   // console.log(a);
    this.adminService.getListeAttenteParMedParIM(this.motCle)
    .subscribe(data => {
      this.listeatt_by_dr = data;
      this.date_clic= new Date();
      console.log("this.listeatt_by_dr"+this.listeatt_by_dr)
    }, err => {
      console.log(err);
    })
  }

  RechercheMedParLocalite(){
    this.adminService.getListeAttenteParMedParMLocalite(this.motCle)
    .subscribe(data => {
      this.listeatt_by_dr = data;
      this.date_clic= new Date();
      console.log("this.listeatt_by_dr"+this.listeatt_by_dr)
    }, err => {
      console.log(err);
    })
  }

  Rendez_vous(id:any,id2:any){   
    /// this.router.navigate(['nucleoicons']);
    if(this.agent_iscrit=="OK"){
      this.router.navigate(['agenda/'+id+"/"+id2]);
    }else{
      Swal.fire({
        title: 'Agent non inscrit au CMS',
        icon: 'info',
        text: '',
        // icone: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Dossiers à fournir',
        cancelButtonText: 'Fermer'
      }).then((result) => {
        if (result.value) {
         this.open();
        } else if (result.dismiss === Swal.DismissReason.cancel) {
        //cancel btn
        }
      });
    }
     
   }

   open() {
    this.popupProcedure.options = { 
   
      cancleBtnClass: "btn btn-default",
      confirmBtnClass: "btn btn-success",
      color: "#A0DE4F",
      showButtons: true,
      animationDuration: 1.5,
      header: "Dossiers à fournir ...",
      widthProsentage: 80,
      animation: "fadeInLeft",
      confirmBtnContent: "Retour",
      cancleBtnContent: "Fermer",
    }

    this.popupProcedure.show(this.popupProcedure.options);
  }

  fermerProcedure(){
    this.popupProcedure.hide();
  }


   

  // {"consulte":3,"role":"MDC","attente":1,"nom":"LAINGO Andriatiana"},
  // [{"consulte":1,"role":"MDC","attente":0,"nom":"ANDRIAMANJATOMANANA Harinirina Francine"}  
  // {"consulte":0,"role":"ASTP","attente":1,"nom":"ANDRIANTSOLO Nirina Mamiharisoa"},  
  // {"consulte":2,"role":"MDC","attente":6,"nom":"RANDRIANASOLO Fanja Francesca Aimée"},
  // {"consulte":0,"role":"OPH","attente":4,"nom":"RASOLOFOJAONA Nivo Harilala"},
  // {"consulte":3,"role":"DST","attente":1,"nom":"RAZAFIMIARANTSOA Herimanana Pascal"},
  // {"consulte":10,"role":"GYN","attente":0,"nom":"RAZAFINDRATOVO Raharison Koloina"},
  // {"consulte":2,"role":"MDC","attente":1,"nom":"RAZAFINDRAZAKA Rivo Lantoniaina"},
  // {"consulte":2,"role":"PED","attente":0,"nom":"RAZANAJATO Rijanarisoa"}],


  // ,{"consulte":24,"role":"MDC","attente":1,"nom":"ANDRIAMASY Rina Didier"},
  // {"consulte":10,"role":"MDC","attente":5,"nom":"RABEKOTONIRINA Vony Nantenaina"},
  // {"consulte":14,"role":"NEU","attente":0,"nom":"RAFEHIVOLA Imisanavalona Hanitrinihaja"},

  // {"consulte":8,"role":"MDC","attente":1,"nom":"RAJAONARIVO Norolala"},
  // {"consulte":8,"role":"MDC","attente":0,"nom":"RANAIVO Roland"},

}
